/* CC-552: visit attribution and successful B2B enquiry conversions. */
(() => {
  'use strict';
  const params = new URLSearchParams(window.location.search);
  const keys = ['gclid', 'gbraid', 'wbraid', 'utm_campaign', 'utm_term'];
  const storageKey = 'wacc_b2b_ad_source';
  const read = (key) => { try { return sessionStorage.getItem(key) || ''; } catch (_) { return ''; } };
  const write = (key, value) => { try { sessionStorage.setItem(key, value); } catch (_) { /* Storage can be unavailable. */ } };
  const incoming = keys.filter((key) => params.get(key)).map((key) => key + '=' + params.get(key).replace(/[|\r\n]/g, ' ').slice(0, 500)).join('|');
  if (incoming) write(storageKey, incoming);
  const source = incoming || read(storageKey);
  document.querySelectorAll('input[name="contact[ad_source]"]').forEach((input) => { input.value = source; });
  const routes = {
    '/pages/corporate-gifting': 'RA7KCJ_FnaEdEP6T97FD',
    '/pages/white-label': '3AfICJrGnaEdEP6T97FD'
  };
  const label = routes[window.location.pathname.replace(/\/$/, '')];
  const successKey = 'wacc_b2b_conversion_' + label;
  const successful = params.get('contact_posted') === 'true' && !!document.querySelector('[data-wacc-enquiry-success]');
  if (label && !params.has('contact_posted')) write(successKey, '');
  let sent = false;
  let configured = false;
  function track() {
    const privacy = window.Shopify && window.Shopify.customerPrivacy;
    if (!privacy || !privacy.marketingAllowed() || !privacy.analyticsProcessingAllowed() || typeof window.gtag !== 'function') return;
    if (!configured) {
      window.gtag('config', 'AW-18089888254', { send_page_view: false });
      configured = true;
    }
    if (!label || !successful || sent || read(successKey)) return;
    sent = true;
    write(successKey, 'sent');
    window.gtag('event', 'conversion', { send_to: 'AW-18089888254/' + label, value: 0, currency: 'GBP' });
  }
  track();
  // The existing consent-controlled Google tag can load after this deferred asset.
  let attempts = 0;
  const timer = window.setInterval(() => { track(); if (configured || ++attempts >= 120) window.clearInterval(timer); }, 500);
  document.addEventListener('visitorConsentCollected', () => { track(); window.setTimeout(track, 1500); });
})();
